import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ITag } from "../models/tags.models";
import { APIResponse } from "src/app/core/models/api-response";
import { environment } from "src/environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { IPageCount } from "src/app/shared/models/page.model";

@Injectable({
  providedIn: 'root',
})
export class TagsService {

  constructor(private http: HttpClient) { }

  public listAllTags(includes?: Array<string>): Observable<APIResponse<ITag>> {
    let params = new HttpParams();
    if (includes) {
      params = params.set('includes', includes.join(','));
    }
    return this.http.get<APIResponse<ITag>>(`${environment.BASE_URL_API}tags`, { params });
  }

  public listTags(page: IPageCount, key?: string): Observable<APIResponse<ITag>> {
    const params = new HttpParams()
      .set('page', page.number)
      .set('limit', page.size)
      .set('key', key!);
    return this.http.get<APIResponse<ITag>>(environment.BASE_URL_API + 'tags' , { params });
  }

  public addTag(tag: ITag): Observable<APIResponse<ITag>> {
    return this.http.post<APIResponse<ITag>>(
      environment.BASE_URL_API + 'tag',
      tag
    );
  }

  public updateTag(id: number, tag: ITag): Observable<APIResponse<ITag>> {
    return this.http.post<APIResponse<ITag>>(
      environment.BASE_URL_API + 'tag/' + id,
      tag
    );
  }

  public deleteTag(id: number): Observable<APIResponse<ITag>> {
    return this.http.delete<APIResponse<ITag>>(
      environment.BASE_URL_API + 'tag/' + id,
    );
  }
}
